<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonButton from "@/components/ArgonButton.vue";
// import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  body.classList.remove("profile-overview");
});
</script>
<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>Usuarios</h6>
    </div>
    <div v-if="loading" class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
    <div class="card-body px-0 pt-0 pb-2" v-else>
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Id
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Usuario
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Nombre
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Permiso
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Status
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                telefono
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Fecha de creacion
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Accion
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                <div class="d-flex px-2">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">{{ user.id }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-sm font-weight-bold mb-0">{{ user.usuario }}</p>
              </td>
              <td>
                <p class="text-sm font-weight-bold mb-0">
                  {{ user.nombre }} {{ user.paterno }}
                </p>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ user.tipo }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ user.status }}</span>
              </td>

              <td>
                <span class="text-xs font-weight-bold">{{
                  user.telefono
                }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  user.fechaCreacion
                }}</span>
              </td>
              <td>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="info"
                  fullWidth
                  size="sm"
                  @click.prevent="updateUser(user)"
                  >Actualizar</argon-button
                >
              </td>
            </tr>
          </tbody>
        </table>
        
          <argon-pagination
            color="info"
            size="lg"
            class="justify-content-center"
          >
            <!-- Botón anterior -->
            <argon-pagination-item
              prev
              :disabled="paginaActual === 1"
              @click.native="getUsuarios(paginaActual - 1)"
            />

            <!-- Páginas -->
            <argon-pagination-item
              v-for="n in totalPaginas"
              :key="n"
              :active="paginaActual === n"
              :label="n.toString()"
              @click.native="getUsuarios(n)"
            />
            <argon-pagination-item
              next
              :disabled="paginaActual === totalPaginas"
              @click.native="getUsuarios(paginaActual + 1)"
            />
          </argon-pagination>
        
      </div>
      <update v-if="userUpdate.id" :user="userUpdate" />
    </div>
  </div>
</template>
<script>
import update from "../Actualizar.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import usuario from "../../api/usuario";
import Swal from "sweetalert2";
export default {
  components: {
    update,
    ArgonPagination,
    ArgonPaginationItem
  },
  data() {
    return {
      loading: true,
      status: null,
      token: "",
      users: [],
      paginaActual: 1,
      totalPaginas: 1,
      userUpdate: {
        id: null,
        nombre: null,
        paterno: null,
        usuario: null,
        telefono: null,
        email: null,
        passwor: null,
        status: null,
        nivel: null,
      },
      model: {
        id: "",
        type: "registro",
        usuario: "",
        password: "",
        confirmPassword: "",
        nombre: "",
        paterno: "",
        telefono: "",
        errorMessage: "",
        status: false,
        token: "",
      },
    };
  },
  onMounted() {},
  created() {
    this.token = localStorage.getItem("token");
    this.getUsuarios(1);
  },
  methods: {
    async getUsuarios(pagina) {
      this.userUpdate.id=null
      if(pagina>this.totalPaginas){
        pagina = this.totalPaginas
      }
      this.paginaActual=pagina
      usuario
        .getUsuarios({ token: this.token, pagina: this.paginaActual })
        .then((result) => {
          if (result.data.usuarios != null) {
            this.users = result.data.usuarios;
            this.usuarios = result.data.usuarios;
            this.paginaActual = result.data.pagina_actual;
            this.totalPaginas = result.data.total_paginas;
            this.loading = false;
          } else {
            Swal.fire({
              title: "Error al obtener usuarios",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateUser(user) {
      this.userUpdate = user;
    },
  },
};
</script>
